import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../../../../../public/icons/workflow/open_subprocess.svg'


const _hoisted_1 = {
  key: 0,
  style: {"text-align":"right"}
}
const _hoisted_2 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_rich_text_editor = _resolveComponent("f-rich-text-editor")!
  const _component_CommonButton = _resolveComponent("CommonButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["htmleditor rich-text-editor", { readonly: _ctx.ReadOnlyMode }])
  }, [
    _createVNode(_component_f_rich_text_editor, {
      class: "f-rich-text-editor",
      html: _ctx.editorHtmlValue,
      translator: _ctx.translate,
      "has-image": true,
      disabled: _ctx.ReadOnlyMode,
      "onUpdate:html": _ctx.onRichTextEditor
    }, null, 8, ["html", "translator", "disabled", "onUpdate:html"]),
    (!_ctx.ReadOnlyMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ShowPopup && _ctx.ShowPopup(...args)), ["prevent"]))
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("img", { src: _imports_0 }, null, -1)
          ]))])
        ]))
      : _createCommentVNode("", true),
    (_ctx.PopupVisible)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.HidePopup(false)))
        }, {
          header: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.Localizer.Localize('Edit')), 1)
          ]),
          body: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_f_rich_text_editor, {
                class: "f-rich-text-editor",
                "has-image": true,
                html: _ctx.popupValue,
                translator: _ctx.translate,
                disabled: _ctx.ReadOnlyMode,
                "onUpdate:html": _cache[1] || (_cache[1] = newValue => _ctx.popupValue = newValue)
              }, null, 8, ["html", "translator", "disabled"])
            ])
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_CommonButton, {
              type: _ctx.ButtonType.Default,
              text: _ctx.Localizer.Localize('Cancel_PascalCase'),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.HidePopup(false)))
            }, null, 8, ["type", "text"]),
            _createVNode(_component_CommonButton, {
              type: _ctx.ButtonType.Primary,
              disabled: _ctx.ReadOnlyMode,
              text: _ctx.Localizer.Localize('Ok_PascalCase'),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.HidePopup(true)))
            }, null, 8, ["type", "disabled", "text"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 2))
}